import { useAccessibilityCheckerStore } from '@/stores/AccessibilityCheckerStore/AccessibilityCheckerStore';
import { CheckerStatus } from '@/Views/BeforeLogin/FreeTools/AccessibilityChecker/AccessibilityChecker.consts';
import { StyledA11yCheckerContainer } from '@/Views/BeforeLogin/FreeTools/AccessibilityChecker/AccessibilityChecker.styles';
import { ScanResults } from '@/Views/BeforeLogin/FreeTools/AccessibilityChecker/ScanResults/ScanResults';
import { ScanUrl } from '@/Views/BeforeLogin/FreeTools/AccessibilityChecker/ScanUrl/ScanUrl';
import { ScanUrlType } from '@/Views/BeforeLogin/FreeTools/AccessibilityChecker/ScanUrl/ScanUrl.consts';

export const A11yScannerSection: React.FC = () => {
  const { status } = useAccessibilityCheckerStore();

  return (
    <StyledA11yCheckerContainer $padding="0px">
      {status === CheckerStatus.PRESCAN ? <ScanUrl type={ScanUrlType.Admin} /> : <ScanResults />}
    </StyledA11yCheckerContainer>
  );
};
